<div [formGroup]="notificationsForm" class="row form-wrapper">
    <div class="col-12">
      <app-checkbox-form-field
        formControlName="selectAll"
        [label]="'label.select_all' | translate"
        (change)="checkFormState()"
      ></app-checkbox-form-field>
    </div>
    <div class="col-12">
      <app-checkbox-form-field
        formControlName="engageApps"
        [label]="'label.engage_apps' | translate"
      ></app-checkbox-form-field>
    </div>
    <div class="col-12">
      <app-checkbox-form-field
        formControlName="requestToEngage"
        [label]="'label.request_to_engage' | translate"
      ></app-checkbox-form-field>
    </div>
    <div class="col-12">
      <app-checkbox-form-field
        formControlName="ownerChanged"
        [label]="'label.owner_changed' | translate"
      ></app-checkbox-form-field>
    </div>
    <div class="col-12">
      <app-checkbox-form-field
        formControlName="ticketStatusChange"
        [label]="'label.ticket_status_change' | translate"
      ></app-checkbox-form-field>
    </div>
    <div class="col-12">
      <app-checkbox-form-field
        formControlName="mentionsInComment"
        [label]="'label.mentions_in_comment' | translate"
      ></app-checkbox-form-field>
    </div>
    <div class="col-12">
      <app-checkbox-form-field
        formControlName="pendingTicketTimeTracking"
        [label]="'label.pending_ticket_time_tracking' | translate"
      ></app-checkbox-form-field>
    </div>
</div>
  